export default "__VITE_ASSET__DQhC_rkH__"